import type {
  SearchPartsByPartNumberQueryKey,
  UseSearchPartsByPartNumberParams,
} from './types';

export const getSearchPartsByPartNumberQueryKey = (
  params: UseSearchPartsByPartNumberParams,
): SearchPartsByPartNumberQueryKey => [
  'quotes',
  'importHistoricalWork',
  'searchPartsByPartNumber',
  params,
];
